import { render, staticRenderFns } from "./InvoiceTypeSetupFilter.vue?vue&type=template&id=90d55064&scoped=true&"
import script from "./InvoiceTypeSetupFilter.vue?vue&type=script&lang=js&"
export * from "./InvoiceTypeSetupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d55064",
  null
  
)

export default component.exports